import { PlusCircleFilled, PlusSquareFilled, UploadOutlined } from '@ant-design/icons'
import { Button, Form } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { HAPUS_IFUNDEFINE } from 'services'
import _Api from 'services/Api/_Api'
import { Button_, Input_, RadioGroup_, Select_ } from 'services/Forms/FormsSatu'
import { msg } from 'services/Toastr/Notify/_Toastr'

function MakananYangBolehTidak(pr) {

  const FORM_ID = 2
  const KONSELING_ID = pr.konseling_id

  const [frm] = Form.useForm()

  const [listMakanan, setlistMakanan] = useState()
  const [loading, setloading] = useState(false)
  const [data, setdata] = useState()


  const isArray = (arr) => {
    return arr instanceof Array;
  }

  const simpanData = () => {
    setloading(true)
    // console.log(val)
    // debugger
    frm.validateFields().then(val => {
      var pure = HAPUS_IFUNDEFINE(val)
      var data_array = {}
      var databukan_array = {}

      for (const key in pure) {
        if (Array.isArray(pure[key])) {
          data_array[key] = pure[key].toString()
        } else {
          databukan_array[key] = pure[key]
        }
      }

    
      // delete cek.centang
      var obj = {
        konseling_id: KONSELING_ID,
        form_id: FORM_ID,
        // diet : ,
        data: {
          ...data_array, ...databukan_array,
          // ...cheklist, 
          // diet: isArray(pure) ? pure.diet.toString() : pure,
          // diitsebelumnya: pure.diitsebelumnya && pure.diitsebelumnya.length > 0 ?  pure.diitsebelumnya.toString() :"",
        }
      }

      _Api.post("simpan-form-konseling", obj).then(rs => {
        msg.auto(rs.data)
        setloading(false)

      })
    }).catch(err => {
      setloading(false)
      msg.error("Silahkan lengkapi data ")
    })
  }

  const getCombo = () => {
    _Api.get("/get-combo-form?form_id=" + FORM_ID + "&konseling_id=" + KONSELING_ID).then(res => {
      // setcombo(res)
      var dt = res.data.combo
      var rc = res.data.record
      var konseling = res.data.konseling?.pembeli

      // {
      //     "id": 26,
      //     "aktif": 1,
      //     "namapembeli": "Faizar Hafidz",
      //     "alamatlengkap": "Mataram",
      //     "id_kotakabupaten": 22,
      //     "nohp": "087",
      //     "email": "pspdfkunizar2023@gmail.com",
      //     "deviceid": null,
      //     "jeniskelamin": null,
      //     "tgllahir": null,
      //     "devicemodel": null,
      //     "updated_at": "2025-03-10T03:03:00.000000Z",
      //     "created_at": "2023-01-09T11:09:45.000000Z"
      // }

      setdata(rc)
      // setlistDiet(res.data.listdiet)

      konseling = {
        "nama": konseling?.namapembeli,
        "pembeli_id": konseling?.id,
        "alamat": konseling?.alamatlengkap,
        "nohp": konseling?.nohp,
      }


      frm.setFieldsValue(konseling)



      var initfield = {}

      rc.map(gg => {
        if (gg.tipedata == "checkbox") {
          initfield.centang = { ...initfield.centang, [gg.fiel_fk]: gg.value == 1 }
        } else
          if (gg.tipedata == "textbox") {
            initfield[gg.fiel_fk] = gg.value
          } else
            if (gg.tipedata == "int") {
              initfield[gg.fiel_fk] = parseInt(gg.value)
            } else
              if (gg.tipedata == "date") {
                initfield[gg.fiel_fk] = moment(gg.value)
              } else
                if (gg.tipedata == "multiple" && gg.value != undefined) {
                  var vlll = gg.value.split(",")
                  initfield[gg.fiel_fk] = vlll
                }
      })


      const mkan = dt.filter(x => x.kelompok_id == "5")
      setlistMakanan(mkan)
      frm.setFieldsValue(initfield)


    })
  }

  useEffect(() => {
    getCombo()
  }, [])

  return (
    <div className='bg-white p-3 rounded'>
      <Form form={frm} layout='vertical'>
        <Row className='gap-3'>
          <Col sm="4" className='border p-3'>
            <h3 className='text-success b u'>  ➤ Makanan Yang Boleh Dikonsumsu</h3>
            <Select_ name="namamakanan_boleh" size="large" label="Nama Makanan" option={listMakanan} val="caption" caption="caption" multiple />
            {/* <Input_ name="string1" size="large" label="Nama Makanan" option={listMakanan} value="id" caption="caption" multiple />
            <Input_ name="string2" size="large" label="Nama Makanan" option={listMakanan} value="id" caption="caption" multiple /> */}

          </Col>
          <Col sm="3" className='border p-3'>
            <h3 className='text-warning b u'> ⤫ Makanan Yang Dibatasi</h3>
            <Select_ name="namamakanan_dibatasi" size="large" label="Nama Makanan" option={listMakanan} val="caption" caption="caption" multiple />
          </Col>
          <Col sm="4" className='border p-3'>
            <h3 className='text-danger b u'> ⤫ Makanan Yang Tidak Boleh Dikonsumsi</h3>
            <Select_ name="namamakanan_tidakboleh" size="large" label="Nama Makanan" option={listMakanan} val="caption" caption="caption" multiple />
          </Col>
        </Row>

      </Form>

      <div className='fixed-bawah' style={{ zIndex: 9999 }}>
        <Row>
          <Button_ sm="2" icon={<UploadOutlined />} block title="Simpan" onClick={simpanData} />
          {/* <Button_ color="orange" sm="2" icon={<ReloadOutlined />} title="Refresh" onClick={getCombo} /> */}
          <Col></Col>
        </Row>
      </div>

    </div>
  )
}

export default MakananYangBolehTidak